import { useState } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { IconButton } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './DropdownTabs.scss';

const defaultFn = () => {};

const DropdownTabs = ({
  items = [],
  name,
  isViewTable = false,
  handleOnClick = defaultFn
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleChange = event => {
    const selectedIndex = items.findIndex(
      item => item.id === event.target.value
    );
    setActiveIndex(selectedIndex);
  };

  const activeTab = items[activeIndex];
  return (
    <div className="dropdown-tabs">
      <div className="dropdown-tabs__controls">
        <div className="dropdown-tabs__select-wrapper">
          <select
            id={name}
            name={name}
            className="dropdown-tabs__select"
            onChange={handleChange}
            value={items[activeIndex].id}
          >
            {items.map(item => (
              <option
                key={`option-${item.id}`}
                value={item.id}
                className="dropdown-tabs__option"
              >
                {item.label}
              </option>
            ))}
          </select>
          <DSIcon
            name="arrow_full_bottom"
            className="dropdown-tabs__chevron-icon"
          />
        </div>
        <IconButton onClick={handleOnClick} className="dropdown-tabs__button">
          {isViewTable ? (
            <>
              <DSIcon name="stats_figures" />
              <span>{trans('charts.button.toggle.chart-view')}</span>
            </>
          ) : (
            <>
              <DSIcon name="format_list_bulleted" />
              <span>{trans('charts.button.toggle.table-view')}</span>
            </>
          )}
        </IconButton>
      </div>
      <div className="dropdown-tabs__content">{activeTab.render()}</div>
    </div>
  );
};

DropdownTabs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      render: PropTypes.func
    })
  ),
  name: PropTypes.string.isRequired,
  isViewTable: PropTypes.bool,
  handleOnClick: PropTypes.func
};

export default DropdownTabs;
